<!-- @format -->

<!-- Template we give to modal factory service to create -->
<ng-template #addToCartSuccessDrawerContent>
  <!-- We detach and move body (with any third party content) here once drawer opens -->
  <ng-container #targetContainer></ng-container>
</ng-template>

<!-- Invisible initial body render - to allow third party content to be injected -->
<div class="hmf-display-none">
  <ng-container
    #initialContainer
  [ngTemplateOutlet]="drawerBody"></ng-container>
</div>

<!-- The actual body of the drawer -->
<ng-template #drawerBody>
  <div id="pdp-add-to-cart-success">
    <div>
      <!-- body content -->
      <div
        id="pdp-add-to-cart-success-header-text"
        class="hmf-display-flex hmf-flex-column hmf-justify-content-center hmf-align-items-center"
        [ngClass]="{ 'hmf-mt-s': !shortenPurchasePathUpdatesATCEnabled }">
        <!-- The class atc-success-inner-header needs to be here for 3rd party content that is being loaded -->
        <div class="atc-success-inner-header hmf-display-flex hmf-align-items-center">
          <homefield-icon
            class="success-icon"
            width="24px"
            height="24px"
            name="sign-circled-check"
            fill="var(--hmf-primary500)">
          </homefield-icon>
          <span class="hmf-subheader-bold-l hmf-ml-xxxs">ADDED TO CART</span>
        </div>
      </div>
      <!-- end header text -->

      @if (displayPreOrderText && preOrderEnabled()) {
        <div
          id="pdp-add-to-cart-success-preorder-msg"
          class="hmf-display-flex hmf-flex-row hmf-justify-content-center hmf-align-items-center hmf-mt-s">
          <homefield-icon
            width="18px"
            height="18px"
            class="pre-order-messaging-icon"
            name="alert-error-outlined"
            fill="var(--hmf-gray700)">
          </homefield-icon>
          <span class="hmf-subheader-s hmf-ml-xxs">
            Pre-Order Product. Ships after {{ preOrderDate | date: 'EEE, MMM d' }}.
          </span>
        </div>
      }
      <!-- end pre order text -->

      @if (
        (selectedFullfillmentOption$ | async) === 'bopis' ||
        (selectedFullfillmentOption$ | async) === 'bopl'
        ) {
        <div
          id="pdp-add-to-cart-success-store-pickup"
          class="hmf-display-flex hmf-flex-row hmf-justify-content-center hmf-align-items-center hmf-body-s">
          For pickup at
          <span class="hmf-body-bold-s">&nbsp;{{ storeDetails?.name }}</span>
        </div>
      }
      <!-- end store pickup text -->

      @if (skuData?.clearance && productHasShoeCategory) {
        <div
          id="pdp-add-to-cart-success-clearance-text"
          class="hmf-display-flex hmf-flex-row hmf-justify-content-center hmf-align-items-center hmf-mt-s">
          <homefield-icon
            width="16px"
            height="16px"
            name="alert-error-outlined">
          </homefield-icon>
          <span class="hmf-ml-xxs">Clearance item. Shoes may not ship in original box.</span>
        </div>
      }
      <!-- end clearance text -->

      <!-- Product Information -->
      @if (atcSuccess) {
        <div
          id="pdp-atc-success-product-information"
          class="hmf-mx-m">
          @if ((selectIsMultipleProducts$ | async) === false) {
            <div
              class="hmf-grid hmf-align-items-center hmf-mt-s hmf-mb-xs">
              <div
                id="pdp-atc-success-product-image"
                class="hmf-col hmf-span-4">
                @if (imageURL) {
                  <img
                    [src]="customImage ? customImage : imageURL"
                    alt=""
                    class="img-fluid" />
                }
                <!-- Using null alt attribute since product name is adjacent to image, image is not necessary to convey add to cart success. -->
              </div>
              <div
                id="pdp-atc-success-product-content"
                class="hmf-col hmf-span-8">
                <span class="hmf-body-s">{{ skuData?.name }}</span>
                @if (skuData?.definingAttributes) {
                  <div
                    id="pdp-add-to-cart-success-product-attributes"
                    class="hmf-body-s"
                    >
                    <ul class="hmf-p-0 hmf-mb-0">
                      @for (
                        attribute of skuData?.definingAttributes; track trackByAttrName($index,
                        attribute)) {
                        <li
                          >
                          <span class="hmf-body-bold-s">{{ attribute.name }}: </span
                            >{{ attribute.value }}
                          </li>
                        }
                        @for (
                          personalizationAttribute of personalization; track trackByPers($index,
                          personalizationAttribute)) {
                          <li
                            >
                            <span class="hmf-body-bold-s"
                              >{{ personalizationAttribute.name }}: </span
                              >{{ personalizationAttribute.value }}
                            </li>
                          }
                        </ul>
                      </div>
                    }
                    @if (!isBundle()) {
                      <div id="pdp-add-to-cart-success-product-price">
                        <span class="hmf-body-bold-s">Price: </span>
                        @if (
                          selectCustomProductPrice$ | async; as customProductPrice) {
                          <span
                            class="hmf-body-s"
                            >{{ userInputQuantity() * customProductPrice | currency }}</span
                            >
                          } @else {
                            <span class="hmf-body-s">{{
                              userInputQuantity() * skuData?.prices?.offerPrice | currency
                            }}</span>
                          }
                        </div>
                      } @else {
                        <div id="pdp-add-to-cart-success-product-price">
                          <span class="hmf-body-bold-s">Price: </span>
                          <span class="hmf-body-s">{{
                            bundlePrice$ | async | currency
                          }}</span>
                        </div>
                      }
                      @if (bundleProducts) {
                        <div>
                          @for (
                            product of bundleProducts; track trackByProdSku(i,
                            product); let i = $index) {
                            <div
                              class="hmf-pt-xxs"
                              >
                              <span class="hmf-body-bold-s atc-panel-product-card-title-label"
                                >Product {{ i + 1 }}:
                              </span>
                              <span class="atc-panel-product-card-title">{{
                                product.sku.name
                              }}</span>
                              <div class="atc-panel-product-card-attributes">
                                <ul class="list-reset">
                                  @for (
                                    attribute of product.sku.definingAttributes; track trackBySku($index,
                                    attribute)) {
                                    <li
                                      >
                                      <span class="bold">{{ attribute.name }}: </span
                                        >{{ attribute.value }}
                                      </li>
                                    }
                                    @if (product.sku?.prices?.offerPrice) {
                                      <li>
                                        <span class="bold">Price: </span
                                          >{{ product.sku.prices.offerPrice | currency }}
                                        </li>
                                      }
                                    </ul>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                        <!-- end #pdp-atc-success-product-content -->
                      </div>
                    }
                    @if (
                      (selectIsMultipleProducts$ | async) &&
                      (selectFBTProducts$ | async); as FBTProducts
                      ) {
                      <div
                        class="multiproduct-container hmf-display-flex hmf-flex-row hmf-justify-content-evenly hmf-align-items-center">
                        <div id="pdp-atc-success-product-image">
                          @if (FBTProducts[0]) {
                            <img
                              [src]="FBTProducts[0].imageURL"
                              alt="" />
                          }
                          <!-- Using null alt attribute since product name is adjacent to image, image is not necessary to convey add to cart success. -->
                        </div>
                        <div>
                          @for (
                            product of FBTProducts; track trackByFBTProduct(i,
                            product); let i = $index) {
                            <div
                              class="hmf-pt-xxs"
                              >
                              <span class="hmf-body-bold-s atc-panel-product-card-title-label"
                                >Product {{ i + 1 }}:
                              </span>
                              <span class="atc-panel-product-card-title">{{ product.title }}</span>
                              <div class="atc-panel-product-card-attributes">
                                <ul class="list-reset">
                                  @for (
                                    attribute of product.definingAttributes; track trackBySku($index,
                                    attribute)) {
                                    <li
                                      >
                                      <span class="bold">{{ attribute.name }}: </span
                                        >{{ attribute.value }}
                                      </li>
                                    }
                                    @if (product?.price) {
                                      <li>
                                        <span class="bold">Price: </span
                                          >{{ product.price | currency }}
                                        </li>
                                      }
                                    </ul>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <!-- end product information -->

                    <!-- CTAs -->
                    <div
                      id="pdp-atc-success-ctas"
                      class="hmf-display-flex hmf-flex-column hmf-align-items-center hmf-mx-m">
                      @if (purchaseWarranty()) {
                        <non-merch-common-externals-purchase-warranty
                          class="hmf-w-100 hmf-mb-m hmf-mt-xs"
						[purchaseWarrantyData]="
							purchaseWarranty()
						"></non-merch-common-externals-purchase-warranty>
                      }

                      @if (
                        !shortenPurchasePathCheckoutButtonATCEnabled) {
                        <a
                          hmf-button
                          variant="primary"
                          id="pdp-atc-succes-cart-btn"
                          class="hmf-mb-s"
                          (click)="fireAnalyticsEvent('PDP_ATCModal_GoToCart')"
                          href="{{ cartURL }}"
                          >Go To Cart</a
                          >
                        } @else {
                          <div class="hmf-display-flex hmf-flex-row hmf-justify-content-evenly hmf-align-items-center">
                            <a
                              hmf-button
                              variant="secondary"
                              id="pdp-atc-success-shorten-purchase-cart-btn"
                              class="hmf-mb-s hmf-mr-xxs atc-cart-checkout-btn"
                              (click)="fireAnalyticsEvent('PDP_ATCModal_GoToCart')"
                              href="{{ cartURL }}"
                              >GO TO CART</a
                              >
                              <a
                                hmf-button
                                variant="primary"
                                id="pdp-atc-success-shorten-purchase-checkout-btn"
                                class="hmf-mb-s atc-cart-checkout-btn"
                                (click)="fireAnalyticsEvent('PDP_ATCModal_Checkout')"
                                href="{{ checkoutBtnURL }}"
                                >CHECKOUT</a
                                >
                              </div>
                            }

                            @defer (when scoreCardData) {
                            <div id="pdp-atc-success-scorecard">
                              <scorecard-scorecard-points
                              [SCORECARD_DATA]="scoreCardData"></scorecard-scorecard-points>
                            </div>
                          }

                          @if (!shortenPurchasePathUpdatesATCEnabled) {
                            <div
                              id="pdp-atc-success-continue-shopping-btn"
                              >
                              <button
                                hmf-button
                                variant="tertiary"
                                (click)="closeDrawer()">
                                Continue Shopping
                              </button>
                            </div>
                          }
                        </div>
                        <!-- end #pdp-atc-success-ctas -->

                        @if (showDSRecommendationsATC) {
                          <div
                            class="hmf-pt-l hmf-mr-s">
                            <product-recommendations-components-ds-product-recommendations
                              [eCodeList]="[product().partNumber]"
                              [eventType]="'detail-page-view'"
                              [placementID]="'frequently-bought-together-high-diversity'"
                              [containerID]="'ATC'"
                              [showViewAllLink]="true"
                              [displayName]="displayName.YMAL"
                              [pageType]="pageType.CART_SUCCESS"
                              [hasGuidVisitor]="newDataScienceRecommendationsEnabledNoPer()"
                              [dsRecsDiversityLevel]="'no-diversity'"
                              [customLinkID]="'PDP_ATC'"
                              [priceRerankLevel]="'high-price-reranking'"
                              [capitalizeTitle]="true"
                              [showSkeletonLoading]="isLoadingStateRecsEnabled()">
                            </product-recommendations-components-ds-product-recommendations>
                          </div>
                        }

                        <!-- Footer CTAs -->
                        @if (chainIdentifierAbbr !== 'calia' && isCartCertonaAvailable === true) {
                          <div
                            id="pdp-atc-success-footer-shopping-btn"
                            class="hmf-display-flex hmf-flex-column hmf-align-items-center">
                            @if (!shortenPurchasePathUpdatesATCEnabled) {
                              <button
                                hmf-button
                                variant="tertiary"
                                (click)="closeDrawer()"
                                >
                                Continue Shopping
                              </button>
                            }
                            @if (
                              !shortenPurchasePathCheckoutButtonATCEnabled) {
                              <a
                                hmf-button
                                variant="primary"
                                id="pdp-atc-success-footer-cart-btn"
                                class="hmf-mb-s"
                                (click)="fireAnalyticsEvent('PDP_ATCModal_GoToCart')"
                                href="{{ cartURL }}"
                                >GO TO CART</a
                                >
                              } @else {
                                <div class="hmf-display-flex hmf-flex-row hmf-justify-content-evenly hmf-align-items-center">
                                  <a
                                    hmf-button
                                    variant="secondary"
                                    id="pdp-atc-success-shorten-purchase-cart-btn"
                                    class="hmf-mb-s hmf-mr-xxs atc-cart-checkout-btn"
                                    (click)="fireAnalyticsEvent('PDP_ATCModal_GoToCart')"
                                    href="{{ cartURL }}"
                                    >GO TO CART</a
                                    >
                                    <a
                                      hmf-button
                                      variant="primary"
                                      id="pdp-atc-success-shorten-purchase-checkout-btn"
                                      class="hmf-mb-s atc-cart-checkout-btn"
                                      (click)="fireAnalyticsEvent('PDP_ATCModal_Checkout')"
                                      href="{{ checkoutBtnURL }}"
                                      >CHECKOUT</a
                                      >
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        </ng-template>

